import script from "./TypeAndLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeAndLayout.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__